import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue';
import type { ResourceDictPropertyValue, ResourceFilterPropertyValue } from '@/venit/services/model/techpubs-cms';
import ResourcePropertiesEditSingleRow from './resource-properties-edit-row-component.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'resource-properties-edit-component',
  props: {
    allPropertiesDictionary: {},
    propertiesList: {},
    editMode: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const formRef = ref();

const allUsedCodes = computed(() => props.propertiesList.map(p => p.propertyCode).filter(Boolean) as string[]);

const onFilterRowRemoved = (filterProperty: ResourceFilterPropertyValue) => {
  const idx = props.propertiesList.findIndex(prop => prop === filterProperty);
  if (idx >= 0) {
    props.propertiesList.splice(idx, 1);
  }
};

const addSearchPropertyRow = () => {
  props.propertiesList.push({
    options: [],
    propertyCode: null,
  });
};

const validate = (): Promise<{ valid: boolean }> => {
  if (!formRef.value) return Promise.resolve({ valid: true });
  return formRef.value.validate();
};

__expose({ addSearchPropertyRow, validate });

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (__props.editMode || __props.propertiesList.length > 0)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        variant: "flat",
        class: "mt-2 mb-2 mx-auto",
        style: {"max-width":"66%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-subtitle-2 py-2 px-4 d-flex align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(__props.editMode ? 'admin-resources.edit.properties.groupTitle' : 'admin-resources.filter.property.groupTitle')), 1 /* TEXT */),
              _createVNode(_component_v_spacer),
              (__props.editMode)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    icon: "",
                    size: "small",
                    variant: "tonal",
                    color: "primary",
                    onClick: addSearchPropertyRow
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("mdi-plus", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "pa-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref_key: "formRef",
                ref: formRef
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.propertiesList, (property) => {
                    return (_openBlock(), _createBlock(ResourcePropertiesEditSingleRow, {
                      key: property.propertyCode,
                      allPropertiesDictionary: __props.allPropertiesDictionary,
                      resourceProperty: property,
                      usedCodes: allUsedCodes.value,
                      onFilterRowRemoved: onFilterRowRemoved
                    }, null, 8 /* PROPS */, ["allPropertiesDictionary", "resourceProperty", "usedCodes"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 512 /* NEED_PATCH */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}
}

})